import { trackClickEvent } from "@foundation/nextjs-gtm";
import UserApiClient from "@foundation/user-api-client";

const USER_API_DOMAIN =
  process.env.NEXT_PUBLIC_REGISTRATION_URL || "https://login.bloomberg.com";
const userApiURL = `${USER_API_DOMAIN}/user-api/graphql`;
const client = new UserApiClient({ userApiUrl: userApiURL });

const ADD_WATCHLIST_RELATIONSHIP = `mutation updateUserInfo($user: UserIdentityInput) {
  upsertProfile (userIdentity: $user, profileInput: {
    dataOrigin: BCONNECT,
    relationships: [WatchlistUser]
  }) {
    id
  }
}`;

const DELETE_WATCHLIST_RELATIONSHIP = `mutation updateUserInfo($user: UserIdentityInput) {
upsertProfile (userIdentity: $user, profileInput: {
  dataOrigin: BCONNECT,
  relationshipDeletions: [WatchlistUser]
}) {
  id
}
}`;

const mapActiontoUDSTQuery: { [key: string]: string } = {
  ADD_WATCHLIST_USER_UDST: ADD_WATCHLIST_RELATIONSHIP,
  DELETE_WATCHLIST_USER_UDST: DELETE_WATCHLIST_RELATIONSHIP,
};

export function updateWatchlistUserUDST(actionType: string) {
  return client
    .request({
      includeCredentials: true,
      document: mapActiontoUDSTQuery[actionType],
    })
    .then((data) => data)
    .catch((error) => {
      console.log("failed to update Watchlist UDST");
      const eventLabel = "Update Watchlist User Relationship Failure";

      trackClickEvent("watchlistError", eventLabel, "error", "watchlist");
    });
}
